import { axiosContentDetail, axiosCmsAPI } from "../axios";
import { COMPANY_PAGE_ACTIONS } from "./actionTypes";
import { getContentWithLanguage } from "../util/language";
import { handleActionError } from "../util/error";

const SubMenuUrl = "/api/v1/company";
const SubMenuDataUrl = "/pub/api/v2/vod/company";
const CompanyIdListUrl = "/companies";

export const getCompanySubMenuAction = ({ id, token, language }) => {
  return dispatch => {
    dispatch({
      type: COMPANY_PAGE_ACTIONS.SUB_MENU._START
    });
    let reqBody = {
      "id" : id,
      "token" : token
    }
    return axiosContentDetail
      .post(`${SubMenuUrl}`,reqBody )
      .then(response => {
        const { data = {} } = response;
        const filteredByLanguage = getContentWithLanguage(data.data, language);
        dispatch({
          type: COMPANY_PAGE_ACTIONS.SUB_MENU._SUCCESS,
          payload: { data: filteredByLanguage }
        });
      })
      .catch(error => {
        handleActionError("Error while fetching company data:", error);
        dispatch({
          type: COMPANY_PAGE_ACTIONS.SUB_MENU._FAILURE
        });
      });
  };
};

export const getCompanySubMenuDataAction = ({ id = 0, offset = 0, max = 6, token, language }) => {
  return dispatch => {
    dispatch({
      type: COMPANY_PAGE_ACTIONS.SUB_MENU_VIDEO._START,
      payload: { offset }
    });
    let reqBody = {
        "id" : id,
        "offset" : offset,
        "max": max,
        "token" : token
      }
    return axiosContentDetail
      .post(`${SubMenuDataUrl}`, reqBody)
      .then(response => {
        const { data = {} } = response;
        const filteredByLanguage = getContentWithLanguage(data.data, language);
        dispatch({
          type: COMPANY_PAGE_ACTIONS.SUB_MENU_VIDEO._SUCCESS,
          payload: { data: filteredByLanguage, offset }
        });
      })
      .catch(error => {
        handleActionError("Error while fetching company-based VOD data:", error);
        dispatch({
          type: COMPANY_PAGE_ACTIONS.SUB_MENU_VIDEO._FAILURE
        });
      });
  };
};

export const getPromotedCompaniesIdList = ({id, language}) => {
  return dispatch => {
    dispatch({
      type: COMPANY_PAGE_ACTIONS.PROMOTED_ID_LIST._START,
    });
    return axiosCmsAPI
      .get(`${CompanyIdListUrl}/${id}`)
      .then(response => {
        const filteredByLanguage = getContentWithLanguage(response.data, language);
        dispatch({
          type: COMPANY_PAGE_ACTIONS.PROMOTED_ID_LIST._SUCCESS,
          payload: { prmCompany: filteredByLanguage}
        });
      })
      .catch(error => {
        handleActionError("Error while fetching company-based data:", error);
        dispatch({
          type: COMPANY_PAGE_ACTIONS.PROMOTED_ID_LIST._FAILURE
        });
      });
  };
}

export const resetCompanyResults = id => {
  return dispatch => {
    dispatch({
      type: COMPANY_PAGE_ACTIONS._RESET
    });
  };
};
